import {cs}             from "@Common/react/chain-services";
import {provideContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {isDevQuan}      from "@Common/ui-components/debug/is-dev-quan";

import {createListingsApis}     from "./listings/listings-apis";
import {createMockListingsApis} from "./listings/mock-listings-apis";
import {createMockNextApis}     from "./next/mock/mock-next-apis";
import {createNextApis}         from "./next/next-apis";

const useMockApis = require("./use-mock-apis");

export const loadDevApis = ({next, onUnauthorized}) => cs(
    ["listingDomain", ({}, next) => Load({
        fetch: async () => {
            return "Mock";
        },
        next,
    })],
    ["apis", ({listingDomain}, next) => next(createDevApis({listingDomain, onUnauthorized}))],

    ({apis}) => provideContext({apis}, next),
);

const createDevApis = ({listingDomain, onUnauthorized}) => ({
    next: useMockApis&&isDevQuan() ? (
        createMockNextApis({})
    ) : (
        createNextApis({
            onUnauthorized,
        })
    ),

    listings: listingDomain && (
        useMockApis&&isDevQuan() ? (
            createMockListingsApis()
        ) : {
            ...createListingsApis({
                fetcher: createProxiedListingFetcher(),
            }),
            domain: "https://apm-dev.xpressdocs.com",
        }
    ),
});

const createProxiedListingFetcher = () => ({
    getJson: async (url) => {
        return await fetch(
            "http://localhost:8523" + url,
            {
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "x-host": "https://apm-dev.xpressdocs.com",
                    // "Authorization":`Basic ${btoa("xpressdocs:poh@z5Ohpea8eeP4Desohh0A")}`
                }
            }
        ).then(res => res.json())
    },
});
